import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import { RootState } from '../store/store';
import { setToken } from '../store/slices/auth/authSlice';

import api from './api';

const user = process.env.REACT_APP_USER || '';
const password = process.env.REACT_APP_PASSWORD || '';

type ActionThunk = ThunkAction<void, RootState, unknown, AnyAction>;

export const authenticate =
    (showLoading = true): ActionThunk =>
        async (dispatch) => {
            const params = {
                UserName: user,
                Password: password,
            };

            const sleep = (seconds: number = 1): Promise<boolean> => {
                return new Promise(resolve => {
                    setTimeout(() => {
                        resolve(true);
                    }, seconds * 1000);
                });
            }

            sleep(1)
            try {
                const resp = await api.post<ResponseLogin>('/api/accounts/signin', params);

                if (resp.data.Result) {
                    const { Token } = resp.data.Response;
                    dispatch(setToken({ token: Token }));
                }

                return {
                    succes: true,
                    error: resp.data?.Result ? 'Autenticación exitosa' : 'Credenciales incorrectas',
                };
            } catch (error) {
                return {
                    succes: false,
                    error: 'Error al autenticar',
                };
            }
        };

export interface ResponseLogin {
    Result: boolean;
    Response: {
        Token: string;
    };
}
